// Furthest playback position ever reached for a watch-history entry.
//
// `maxPosition` is the monotonic high-water mark written by useSync; it never
// decreases, so status/progress derived from it can't regress when a learner
// rewatches or scrubs back (the welcome-video "Completed flipped back to In
// Progress" bug). `lastPosition` is still consulted because entries written
// before maxPosition existed don't have it, and a server-side merge from an
// old client can advance lastPosition alone.
const getFurthestPosition = (entry) => {
  const last = Number(entry?.lastPosition);
  const max = Number(entry?.maxPosition);
  return Math.max(
    Number.isFinite(last) && last > 0 ? last : 0,
    Number.isFinite(max) && max > 0 ? max : 0,
  );
};

export default getFurthestPosition;
